import type { SessionData } from 'owa-service/lib/types/SessionData';

export default function (): Promise<SessionData> {
    return Promise.resolve({
        owaUserConfig: {
            SessionSettings: {
                DefaultFolderNames: undefined,
            },
            UserOptions: {
                TimeZone: 'UTC',
                MailboxTimeZoneOffset: [],
                HourIncrement: 30, // Work Item 54878: Find a better way to initialize these hardcoded values in order to localize properly
                DateFormat: 'yyyy-MM-dd',
                TimeFormat: 'h:mm tt',
            },
            SegmentationSettings: {},
        },
        language: 'en',
        features: [],
    });
}
